export default __webpack_public_path__ + "static/media/kick-out.7c29b018.svg";